import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { knowledgeService } from '../../../services/KnowledgeService';
import { knowledgeQueryKeys } from '../knowledgeQueryKeys';

export function useKnowledgeDatabasesQuery() {
  const { user } = useAuth();
  const isEnabled = Boolean(user);

  return useQuery({
    queryKey: knowledgeQueryKeys.databases(),
    enabled: isEnabled,
    queryFn: () => knowledgeService.listDatabases(),
  });
}
